import type { WidgetConfig } from "@/lib/schema";
import type { AnyWidgetModule } from "@/widgets/registry";

interface Props {
  module: AnyWidgetModule;
  config: WidgetConfig;
  onChange: (patch: Partial<WidgetConfig>) => void;
  error?: string;
}

export function ScoringField({ module, config, onChange, error }: Props) {
  if (module.scoring !== "points") return null;
  const maxFn = module.maxScoreWeek;
  if (!maxFn) return null;

  const max = maxFn(config);
  const weekGoal = (config as { weekGoal: number }).weekGoal;
  const displayValue = Number.isFinite(weekGoal) ? weekGoal : "";

  return (
    <div className="setting-row">
      <label className="setting-label" htmlFor={`weekgoal-${config.id}`}>
        Ukesmål
        {Number.isFinite(max) ? (
          <small data-testid="weekgoal-max-hint">
            Maks oppnåelig denne uka: {max}p
          </small>
        ) : null}
      </label>
      <div className="setting-control">
        <div className="num-input">
          <input
            id={`weekgoal-${config.id}`}
            type="number"
            min={0}
            step={0.25}
            max={Number.isFinite(max) ? max : undefined}
            value={displayValue}
            onChange={(e) => {
              const v = e.target.value;
              const next = v === "" ? Number.NaN : Math.max(0, Number(v) || 0);
              onChange({ weekGoal: next } as Partial<WidgetConfig>);
            }}
            data-testid="widget-weekgoal-input"
          />
          <span className="unit">p</span>
        </div>
        {error ? (
          <p className="field-error" data-testid="widget-weekgoal-error">
            {error}
          </p>
        ) : null}
      </div>
    </div>
  );
}
